import { render, staticRenderFns } from "./MailSettings.vue?vue&type=template&id=20276730&scoped=true"
import script from "./MailSettings.vue?vue&type=script&lang=js"
export * from "./MailSettings.vue?vue&type=script&lang=js"
import style0 from "./MailSettings.vue?vue&type=style&index=0&id=20276730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20276730",
  null
  
)

export default component.exports